module.exports = __webpack_public_path__ + "img/m5-3.3fa04c5b.png";